import { axiosUser } from '@axios/axiosInstances';

const MINI_POS_REPORT_URL = '/mini-pos/reports';
const MINI_POS_ORDER_URL = '/mini-pos/orders';

export const createOrderRequest = async body => {
  const { data } = await axiosUser.post(MINI_POS_ORDER_URL, body);
  return data;
};

export const getOrdersRequest = async params => {
  const { data } = await axiosUser.get(MINI_POS_ORDER_URL, { params });
  return data;
};

export const getOrderByIdRequest = async orderId => {
  const { data } = await axiosUser.get(`${MINI_POS_ORDER_URL}/${orderId}`);
  return data;
};

export const createSubOrderProductRequest = async (orderId, payload) => {
  const { data } = await axiosUser.post(`${MINI_POS_ORDER_URL}/${orderId}/sub-orders/active/add-product`, payload);
  return data;
};

export const updateSubOrderProductRequest = async (orderId, subOrderId, productId, payload) => {
  const { data } = await axiosUser.patch(
    `${MINI_POS_ORDER_URL}/${orderId}/sub-orders/${subOrderId}/products/${productId}`,
    payload
  );
  return data;
};

export const sendSubOrderProductRequest = async (orderId, subOrderId, payload = {}) => {
  const { data } = await axiosUser.patch(
    `${MINI_POS_ORDER_URL}/${orderId}/sub-orders/${subOrderId}/send-order`,
    payload
  );
  return data;
};

// /orders/:orderId/sub-orders/:subOrderId/pay-order
export const payOrderRequest = async payload => {
  const { data } = await axiosUser.post(`${MINI_POS_ORDER_URL}/${payload.orderId}/pay-order`, payload);
  return data;
};

export const calcPriceRequest = async payload => {
  const { data } = await axiosUser.post(`order/calc-price`, payload);
  return data;
};

export const calcPaymentRequest = async payload => {
  const { data } = await axiosUser.post(`order/calc-payment`, payload);
  return data;
};

export const getCoupon = async payload => {
  const { data } = await axiosUser.post(`${MINI_POS_ORDER_URL}/get-coupons`, payload);
  return data;
};

export const deleteSubOrderProductRequest = async (orderId, subOrderId, productId) => {
  await axiosUser.delete(`${MINI_POS_ORDER_URL}/${orderId}/sub-orders/${subOrderId}/products/${productId}`);
};

export const deleteSubOrderRequest = async (orderId, subOrderId) => {
  await axiosUser.delete(`${MINI_POS_ORDER_URL}/${orderId}/sub-orders/${subOrderId}`);
};

export const getConversionRatesRequest = async () => {
  const { data } = await axiosUser.get('/rate');
  return data;
};

export const voidSubOrderRequest = async (orderId, subOrderId) => {
  const { data } = await axiosUser.patch(`${MINI_POS_ORDER_URL}/${orderId}/sub-orders/${subOrderId}/void`);
  return data;
};

export const voidOrderRequest = async (orderId, payload = {}) => {
  const { data } = await axiosUser.patch(`${MINI_POS_ORDER_URL}/${orderId}/void`, payload);
  return data;
};

export const updateSubOrderRequest = async (orderId, subOrderId, payload) => {
  const { data } = await axiosUser.patch(`${MINI_POS_ORDER_URL}/${orderId}/sub-orders/${subOrderId}`, payload);
  return data;
};

export const getShopUserByPhone = async phone => {
  const { data } = await axiosUser.get(`/user/shopUser`, { params: { phone } });
  return data;
};

export const getPaymentsRequest = async () => {
  const { data } = await axiosUser.get(`/payment`);
  return data;
};

export async function exportReportRequest(payload) {
  const response = await axiosUser.post(
    `${MINI_POS_REPORT_URL}/export`,
    payload,
    {
      responseType: "blob"
    }
  );

  const disposition = response.headers["content-disposition"];

  let fileName = "Report.xlsx";

  if (disposition) {
    const match = disposition.match(/filename="(.+)"/);
    if (match) fileName = match[1];
  }

  return {
    blob: response.data,
    fileName
  };
}